import { fade, makeStyles } from '@material-ui/core';
export var useStyles = makeStyles(function (theme) { return ({
    primary: {
        boxShadow: 'none',
        minWidth: 128,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.secondary.main,
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: theme.palette.primary.dark,
            boxShadow: 'none',
        },
        '&:disabled, &:hover.Mui-disabled': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.secondary.light,
        },
        '&.MuiButton-containedSizeSmall': {
            minWidth: '100px',
            minHeight: '20px',
            padding: theme.spacing(0.75, 1.5),
            lineHeight: theme.spacing(0.1),
            marginLeft: theme.spacing(2),
            '& .MuiButton-label': {
                fontSize: '10px',
            },
        },
    },
    secondary: {
        backgroundColor: theme.palette.grey[100],
        boxShadow: 'none',
        minWidth: 128,
        '&:hover': {
            backgroundColor: fade(theme.palette.grey[100], 0.6),
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: fade(theme.palette.grey[200], 0.6),
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: theme.palette.grey[200],
        },
        '&:disabled, &:hover.Mui-disabled': {
            backgroundColor: fade(theme.palette.grey[100], 0.6),
        },
    },
    ghost: {
        minWidth: 128,
        color: theme.palette.text.primary,
        borderColor: theme.palette.grey[100],
        '&:hover, &:focus': {
            backgroundColor: 'unset',
            borderColor: theme.palette.secondary.main,
            color: theme.palette.primary.main,
        },
        '&:active': {
            borderColor: theme.palette.primary.dark,
            color: theme.palette.primary.dark,
        },
    },
    text: {
        '&:hover, &:focus': {
            backgroundColor: fade(theme.palette.grey[100], 0.6),
        },
        '&:active': {
            backgroundColor: theme.palette.grey[100],
        },
    },
    link: {
        color: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: 'unset',
            color: theme.palette.secondary.main,
        },
        '&:focus': {
            color: theme.palette.secondary.main,
            border: "1px solid " + theme.palette.secondary.main,
        },
        '&:active': {
            color: theme.palette.primary.dark,
        },
        '&:disabled': {
            color: theme.palette.secondary.light,
        },
    },
    dotted: {
        borderColor: theme.palette.grey[100],
        borderStyle: 'dashed',
        '&:hover, &:focus': {
            borderColor: theme.palette.secondary.main,
            color: theme.palette.secondary.main,
            backgroundColor: 'unset',
        },
        '&:active': {
            borderColor: theme.palette.grey[100],
        },
        '&:disabled': {
            borderStyle: 'dashed',
        },
    },
}); });
